module.exports = "<nav-left></nav-left>\r\n<top-module-nav class=\"top-nav\">\r\n</top-module-nav>\r\n<div class=\"fixed-right-content\" ui-view></div>";